<div class="app">

<!-- SIDEBAR -->
<aside class="sidebar" id="sidebar">
  <div class="sb-logo">
    <!-- Icon column: shows portal icon when expanded, ">" expand btn when collapsed -->
    <div class="sb-logo-icon-wrap" onclick="document.getElementById('sidebar').classList.contains('slim')&&toggleSidebar()" style="position:relative;cursor:default">
      <!-- Portal icon (visible when expanded) -->
      <div class="sb-logo-icon sb-portal-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="5" r="2"/><circle cx="5" cy="19" r="2"/><circle cx="19" cy="19" r="2"/>
          <line x1="12" y1="7" x2="5" y2="17"/><line x1="12" y1="7" x2="19" y2="17"/><line x1="5" y1="19" x2="19" y2="19"/>
        </svg>
      </div>
      <!-- Expand button (visible when collapsed, replaces portal icon) -->
      <button class="sb-expand-btn" onclick="toggleSidebar()" title="Expand sidebar">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </button>
    </div>
    <!-- Text + collapse button (hidden when collapsed) -->
    <div class="sb-logo-body">
      <div>
        <div class="sb-logo-name">DU SPL Portal</div>
        <div class="sb-logo-sub">DataUnveil · Ops &amp; PM</div>
      </div>
      <button id="sidebar-collapse-btn" onclick="toggleSidebar()" title="Collapse sidebar">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Hidden client select for JS compatibility -->
  <select id="clientSelect" onchange="switchClient(this.value)" style="display:none"></select>
  <div id="clientColorBar" style="display:none"></div>
  <div id="wf-shortcuts" style="display:none"></div>

  <nav class="sb-nav">
    <button class="nav-item" id="n-dashboard" onclick="unifiedGo('dashboard')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg></span><span>Dashboard</span></button>
    <div class="nav-sep"></div>
    <div class="nav-label">Master Data</div>
    <button class="nav-item" id="n-clients"   onclick="unifiedGo('clients')"  ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg></span><span>Clients</span></button>
    <button class="nav-item" id="n-brands"    onclick="unifiedGo('brands')"   ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg></span><span>Brands / Products</span></button>
    <button class="nav-item" id="n-partners"  onclick="unifiedGo('partners')" ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg></span><span>Data Partners</span></button>
    <div class="nav-sep"></div>
    <div class="nav-label">Operations</div>
    <button class="nav-item" id="n-contacts"  onclick="unifiedGo('contacts')" ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></span><span>Contacts & DLs</span></button>
    <button class="nav-item" id="n-dispatch"  onclick="unifiedGo('dispatch')" ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg></span><span>Email Dispatch</span></button>
    <button class="nav-item" id="n-templates" onclick="unifiedGo('templates')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/></svg></span><span>Email Templates</span></button>
    <button class="nav-item" id="n-ip"        onclick="unifiedGo('ip')"       ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></span><span>IP Whitelisting</span></button>
    <button class="nav-item" id="n-feeds"     onclick="unifiedGo('feeds')"    ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg></span><span>Inbound Feeds</span></button>
    <div class="nav-sep"></div>
    <div class="nav-label">Scheduling</div>
    <button class="nav-item" id="n-calls"     onclick="unifiedGo('calls')"    ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></span><span>Call Schedule</span></button>
    <button class="nav-item" id="n-holidays"  onclick="unifiedGo('holidays')" ><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></span><span>Holiday Schedules</span></button>
    <div class="nav-sep"></div>
    <div class="nav-label">Platforms</div>
    <button class="nav-item" id="n-platforms" onclick="unifiedGo('platforms')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg></span><span>Pharmacy Platforms</span></button>
    <div class="nav-sep"></div>
    <div class="nav-label">Governance</div>
    <button class="nav-item" id="n-agreements" onclick="unifiedGo('agreements')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/></svg></span><span>Agreements</span></button>
    <div class="nav-sep"></div>
    <div class="nav-label">SPL Tracker</div>
    <button class="nav-item" id="n-spl-overview" onclick="unifiedGo('spl-overview')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg></span><span>Overview</span></button>
    <div id="spl-nav-sections"></div>
    <button class="nav-item nav-add" onclick="splAddSection()" style="color:var(--text-muted)"><span class="nav-ic">＋</span><span>Add Task</span></button>
    <div class="nav-sep"></div>
    <div class="nav-label">Payment Calculator</div>
    <button class="nav-item" id="n-pc-release" onclick="unifiedGo('pc-release')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20V10"/><path d="M18 20V4"/><path d="M6 20v-4"/></svg></span><span>Release Tracking</span></button>
    <button class="nav-item" id="n-pc-issues" onclick="unifiedGo('pc-issues')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg></span><span>Issue Tracking</span></button>
    <div class="nav-sep"></div>
    <div class="nav-label">Dynamic Modules</div>
    <button class="nav-item" id="n-dyn-holidays" onclick="unifiedGo('dyn-holidays')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></span><span>Holiday Calendar</span></button>
    <button class="nav-item" id="n-dyn-calls" onclick="unifiedGo('dyn-calls')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.22 1.21 2 2 0 012.22 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.16 6.16l1.07-1.07a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg></span><span>Call Scheduler</span></button>
    <button class="nav-item" id="n-dyn-releases" onclick="unifiedGo('dyn-releases')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20V10"/><path d="M18 20V4"/><path d="M6 20v-4"/></svg></span><span>Release Tracker</span></button>
    <button class="nav-item" id="n-dyn-mom" onclick="unifiedGo('dyn-mom')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg></span><span>MoM Manager</span></button>
    <button class="nav-item" id="n-dyn-impl" onclick="unifiedGo('dyn-impl')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg></span><span>Implementation Tracker</span></button>


    <button class="nav-item" id="n-dyn-testing" onclick="unifiedGo('dyn-testing')"><span class="nav-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v11m0 0H5m4 0h10m-10 0v4a2 2 0 002 2h4a2 2 0 002-2v-4m0 0h4"/></svg></span><span>Testing Tracker</span></button>
  </nav>


</aside>

<!-- MAIN -->
<div class="main">
  <header class="topbar" id="mainTopbar">
    <div class="breadcrumb" style="flex:1;min-width:0;display:flex;align-items:center;gap:8px">
      <span id="bcParent" style="color:var(--text-muted);font-weight:600;font-size:13.5px;white-space:nowrap;display:none"></span>
      <span id="bcSep" style="color:var(--border-lt);font-size:13px;display:none">|</span>
      <span class="bc-page" id="bcPage" style="color:var(--text);font-weight:800;font-size:15px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">Dashboard</span>
    </div>
    <div class="topbar-right">
      <div class="tb-search"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="opacity:.5"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg><input placeholder="Search…" onkeyup="quickSearch(event)"></div>
      <button class="theme-toggle" id="theme-btn" onclick="toggleTheme()" title="Toggle light / dark theme">
        <svg id="theme-icon-dark" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>
        <svg id="theme-icon-light" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display:none"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
      </button>
      <button class="tb-btn tb-btn-ghost" onclick="openClientSwitcher()" id="topbar-client-btn" style="display:flex;align-items:center;gap:6px;padding:5px 10px">
        <div id="topbar-client-dot" style="width:7px;height:7px;border-radius:50%;background:var(--cc);flex-shrink:0"></div>
        <span id="topbar-client-name" style="font-size:12.5px;font-weight:700;color:var(--cc)">Sanofi</span>
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div style="display:flex;align-items:center;gap:4px;margin-left:4px">
        <span style="color:var(--text-muted);font-size:11px;font-weight:600">Brand:</span>
        <select id="topbar-brand-select" onchange="switchBrand(this.value)" style="font-family:var(--font);font-size:12px;font-weight:600;padding:4px 24px 4px 8px;border:1.5px solid var(--border);border-radius:var(--r-sm);background:var(--surface);color:var(--cc);cursor:pointer;min-width:120px">
          <option value="">All Brands</option>
        </select>
      </div>
    </div>
  </header>

  <!-- Alert pulse (hidden, kept for JS compatibility) -->
  <div id="ctxBanner" style="display:none">
    <div id="ctxDot"></div>
    <span id="ctxName"></span>
    <span id="ctxDetail"></span>
    <span id="ctxStats"></span>
    <div id="ops-alert-pulse" style="display:none" onclick="unifiedGo('ops-overview')">
      <div></div>
      <span id="alert-count-text"></span>
    </div>
  </div>

  <div class="content" id="content"><div class="screen" id="screen"></div></div>

<!-- PMP CONTENT AREA (shown when PMP screens are active) -->
<div id="pmp-content-area" style="display:none;flex:1;overflow-y:auto;padding:24px 28px;background:var(--bg);min-height:0"><div id="pmp-back-area"></div>


    <!-- DASHBOARD -->
    <div class="view active" id="pmp-view-dashboard">
      <div class="page-header">
        <div>
          <div class="page-title" id="pmp-dash-title">PM Dashboard</div>
          <div class="page-sub" id="pmp-dash-date" style="display:none"></div>
        </div>
      </div>
      <div class="kpi-row">
        <div class="kpi" style="--kpi-c:var(--accent)" onclick="unifiedGo('projects')">
          <div class="kpi-icon">📁</div><div class="kpi-value" id="kpi-total">0</div>
          <div class="kpi-label">Total Projects</div><div class="kpi-trend">↑ Click to view</div>
        </div>
        <div class="kpi" style="--kpi-c:var(--green)" onclick="navOpenMilestones()" style="cursor:pointer">
          <div class="kpi-icon">🏁</div><div class="kpi-value" id="kpi-ms">0</div>
          <div class="kpi-label">Total Milestones</div><div class="kpi-trend" id="kpi-ms-t">—</div>
        </div>
        <div class="kpi" style="--kpi-c:var(--orange)" onclick="navOpenTasks()">
          <div class="kpi-icon">✅</div><div class="kpi-value" id="kpi-open">0</div>
          <div class="kpi-label">Open Tasks</div><div class="kpi-trend warn" id="kpi-open-t">—</div>
        </div>
        <div class="kpi" style="--kpi-c:var(--red)" onclick="navOverdueTasks()">
          <div class="kpi-icon">⚠️</div><div class="kpi-value" id="kpi-overdue">0</div>
          <div class="kpi-label">Overdue Items</div><div class="kpi-trend down">Click to review</div>
        </div>
      </div>
      <div class="two-col" style="margin-bottom:24px;">
        <div class="card">
          <div class="card-header"><div class="section-title" style="margin:0">Project Health</div><button class="btn btn-ghost btn-sm" onclick="unifiedGo('projects')">View all →</button></div>
          <div id="dash-health"></div>
        </div>
        <div class="card">
          <div class="card-header"><div class="section-title" style="margin:0">Recent Activity</div><button class="btn btn-ghost btn-sm" onclick="unifiedGo('activity')">View all →</button></div>
          <div id="dash-activity"></div>
        </div>
      </div>
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;">
        <div style="font-size:14px;font-weight:700;color:var(--text);">Active Projects</div>
        <button class="btn btn-ghost btn-sm" onclick="unifiedGo('projects')">View all →</button>
      </div>
      <div class="projects-grid" id="dash-projects"></div>
    </div>

    <!-- ALL PROJECTS -->
    <div class="view" id="pmp-view-projects">
      <div class="page-header">
        <div><div class="page-title">All Projects</div><div class="page-sub">Manage and track every project.</div></div>
        <div class="page-header-actions">
          <button class="btn btn-outline btn-sm" onclick="openExcelModal()">📥 Import Excel</button>
          <button class="btn btn-primary btn-sm" id="new-proj-btn" onclick="pmpOpenModal('modal-project')">＋ New Project</button>
        </div>
      </div>
      <div class="filter-row">
        <select class="filter-select" id="f-dept" onchange="renderProjects()"><option value="">All Departments</option><option>Engineering</option><option>Design</option><option>Marketing</option><option>Product</option><option>Operations</option><option>Finance</option><option>HR</option></select>
        <select class="filter-select" id="f-prio" onchange="renderProjects()"><option value="">All Priorities</option><option value="critical">Critical</option><option value="high">High</option><option value="normal">Normal</option><option value="low">Low</option></select>
        <select class="filter-select" id="f-stat" onchange="renderProjects()"><option value="">All Statuses</option><option value="active">In Progress</option><option value="done">Completed</option><option value="hold">On Hold</option></select>
      </div>
      <div class="projects-grid" id="all-projects"></div>
    </div>

    <!-- PROJECT DETAIL -->
    <div class="view" id="pmp-view-detail">
      <div id="detail-content"></div>
    </div>

    <!-- MILESTONES -->
    <div class="view" id="pmp-view-milestones">
      <div class="page-header">
        <div><div class="page-title">Milestones</div><div class="page-sub">All milestones across projects.</div></div>
        <div class="page-header-actions">
          <select class="filter-select" id="ms-proj-filter" onchange="renderMilestones()"><option value="">All Projects</option></select>
          <select class="filter-select" id="ms-status-filter" onchange="renderMilestones()"><option value="">All Statuses</option><option value="done">Completed</option><option value="active">In Progress</option><option value="pending">Pending</option><option value="hold">On Hold</option></select>
        </div>
      </div>
      <div id="milestones-content"></div>
    </div>

    <!-- ARCHIVED PROJECTS -->
    <div class="view" id="pmp-view-archived">
      <div class="page-header">
        <div><div class="page-title">📦 Archived Projects</div><div class="page-sub">Restore archived projects to make them active again.</div></div>
      </div>
      <div class="projects-grid" id="archived-grid"></div>
    </div>

    <!-- KANBAN -->
    <div class="view" id="pmp-view-kanban">
      <div class="page-header">
        <div><div class="page-title">Kanban Board</div><div class="page-sub">Drag tasks to update status.</div></div>
        <div class="page-header-actions">
          <select class="filter-select" id="k-proj" onchange="renderKanban()"><option value="">All Projects</option></select>
          <button class="btn btn-primary btn-sm" onclick="openQuickTask()">＋ Quick Task</button>
        </div>
      </div>
      <div class="kanban-outer"><div class="kanban-board" id="kanban-board"></div></div>
    </div>

    <!-- CLIENTS -->
    <div class="view" id="pmp-view-clients">
      <div class="page-header">
        <div><div class="page-title">Clients</div><div class="page-sub">Manage client relationships and status.</div></div>
        <div class="page-header-actions">
          <button class="btn btn-primary btn-sm" id="add-client-btn" onclick="pmpOpenModal('modal-client')">＋ Add Client</button>
        </div>
      </div>
      <div class="card" style="overflow:hidden;">
        <table class="data-table">
          <thead><tr><th>Client</th><th>Start Date</th><th>Go Live</th><th>Status</th><th>Client Contact</th><th>Onshore Lead</th><th>OPS Lead</th><th>SPL</th><th></th></tr></thead>
          <tbody id="clients-tbody"></tbody>
        </table>
      </div>
    </div>

    <!-- TIMELINE -->
    <div class="view" id="pmp-view-timeline">
      <div class="page-header"><div><div class="page-title">Project Timeline</div><div class="page-sub">Gantt-style overview.</div></div></div>
      <div class="card"><div class="gantt-wrap" id="gantt-content"></div></div>
    </div>

    <!-- ALL TASKS -->
    <div class="view" id="pmp-view-tasks">
      <div class="page-header">
        <div><div class="page-title">All Tasks</div><div class="page-sub">Every task across all projects.</div></div>
        <div class="page-header-actions">
          <button class="btn btn-primary btn-sm" id="create-task-btn" onclick="openCreateTask()">＋ Create Task</button>
        </div>
      </div>
      <div class="filter-row">
        <select class="filter-select" id="tf-proj" onchange="renderTasks()"><option value="">All Projects</option></select>
        <select class="filter-select" id="tf-stat" onchange="renderTasks()"><option value="">All Statuses</option><option value="backlog">Backlog</option><option value="to-do">To Do</option><option value="in-progress">In Progress</option><option value="review">Review</option><option value="done">Done</option></select>
        <select class="filter-select" id="tf-who" onchange="renderTasks()"><option value="">All Assignees</option></select>
      </div>
      <div class="card" style="overflow:auto;">
        <table class="data-table" id="task-table">
          <thead><tr><th>Task</th><th>Client</th><th>Project</th><th>Milestone</th><th>Assignee</th><th>Due Date</th><th>Status</th><th>Comment</th></tr></thead>
          <tbody id="tasks-tbody"></tbody>
        </table>
      </div>
    </div>

    <!-- RESOURCES -->
    <div class="view" id="pmp-view-resources">
      <div class="page-header">
        <div><div class="page-title">Resources</div><div class="page-sub">Team allocation and project assignment.</div></div>
        <div class="page-header-actions">
          <button class="btn btn-primary btn-sm" onclick="openAddResourceModal()">＋ Add Resource</button>
        </div>
      </div>
      <div id="resources-content"></div>
    </div>

    <!-- REPORTS -->
    <div class="view" id="pmp-view-reports">
      <div class="page-header"><div><div class="page-title">Reports & Analytics</div></div></div>
      <div id="reports-content"></div>
    </div>

    <!-- ACTIVITY LOG -->
    <div class="view" id="pmp-view-activity">
      <div class="page-header"><div><div class="page-title">Activity Log</div></div></div>
      <div class="card"><div id="activity-feed"></div></div>
    </div>

  
</div>
</div>
</div>

<!-- Modal -->
<div class="modal-bg" id="modalBg">
  <div class="modal" id="modalBox">
    <div class="modal-hd"><div class="modal-title" id="modalTitle"></div><button class="modal-x" onclick="closeModal()"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div>
    <div class="modal-bd" id="modalBd"></div>
    <div class="modal-ft" id="modalFt"></div>
  </div>
</div>
<!-- Confirm -->
<div class="confirm-bg" id="confirmBg">
  <div class="confirm-box">
    <div class="confirm-icon" id="cIcon">⚠️</div>
    <div class="confirm-title" id="cTitle">Are you sure?</div>
    <div class="confirm-msg" id="cMsg"></div>
    <div id="cExtra"></div>
    <div class="confirm-btns"><button class="btn btn-secondary" onclick="closeConfirm()">Cancel</button><button class="btn btn-danger" id="cOkBtn" onclick="doConfirm()">Delete</button></div>
  </div>
</div>
<!-- Drawer -->
<div class="drawer-bg" id="drawerBg" onclick="closeDrawer()"></div>
<div class="drawer" id="drawer">
  <div class="drawer-hd"><div class="modal-title" id="drawerTitle"></div><button class="modal-x" onclick="closeDrawer()"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div>
  <div class="drawer-bd" id="drawerBd"></div>
</div>
<!-- MODALS -->
<!-- New Project -->
<div class="modal-bg" id="modal-project">
  <div class="modal">
    <div class="modal-header"><div class="modal-title">Create New Project</div><button class="modal-close" onclick="pmpCloseModal('modal-project')">✕</button></div>
    <div class="modal-sub">Client/Brand → Project → Milestones → Tasks</div>
    <div class="step-bar">
      <div class="step-active">1 · Client</div>
      <div class="step-idle">2 · Details</div>
      <div class="step-idle">3 · Team</div>
    </div>
    <div class="inp-group">
      <label class="inp-label">Client / Brand *</label>
      <select class="inp" id="np-client" onchange="onNpClientChange()">
        <option value="">— Select Client / Brand —</option>
      </select>
      <div style="font-size:11.5px;color:var(--text3);margin-top:4px;">No client? <span style="color:var(--accent);cursor:pointer;text-decoration:underline;" onclick="pmpCloseModal('modal-project');pmpOpenModal('modal-client')">Add new client →</span></div>
    </div>
    <div class="client-info-chip" id="np-client-chip"></div>
    <div style="margin-top:10px">
      <label style="font-size:12px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:6px">Brand <span style="font-weight:400;text-transform:none;letter-spacing:0">(Client → Brand → Project)</span></label>
      <select class="inp" id="np-brand" style="width:100%;padding:9px 12px;border:1.5px solid var(--border);border-radius:var(--r-sm);background:var(--input-bg);color:var(--text);font-family:var(--font);font-size:13px">
        <option value="">— Select Brand (optional) —</option>
      </select>
    </div>
    <div class="inp-group">
      <label class="inp-label">Project Name *</label>
      <input class="inp" id="np-name" placeholder="e.g. Customer Portal Redesign">
    </div>
    <div class="inp-group">
      <label class="inp-label">Motive / Goal</label>
      <textarea class="inp" id="np-motive" placeholder="What is this project trying to achieve?"></textarea>
    </div>
    <div class="form-row">
      <div class="inp-group">
        <label class="inp-label">Project Lead *</label>
        <input class="inp" id="np-lead" placeholder="Full name">
      </div>
      <div class="inp-group">
        <label class="inp-label">Department</label>
        <select class="inp" id="np-dept"><option value="General">Select dept.</option><option>Engineering</option><option>Design</option><option>Marketing</option><option>Product</option><option>Operations</option><option>Finance</option><option>HR</option></select>
      </div>
    </div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">Start Date</label><input class="inp" type="date" id="np-start"></div>
      <div class="inp-group"><label class="inp-label">End Date (Tentative)</label><input class="inp" type="date" id="np-end"></div>
    </div>
    <div class="inp-group">
      <label class="inp-label">Priority</label>
      <select class="inp" id="np-prio"><option value="normal">Normal</option><option value="high">High</option><option value="critical">Critical</option><option value="low">Low</option></select>
    </div>
    <div class="inp-group">
      <label class="inp-label">Team Members (Enter to add)</label>
      <div class="chip-wrap" id="chip-wrap" onclick="document.getElementById('chip-in').focus()">
        <input id="chip-in" placeholder="Type name…" onkeydown="handleChip(event)">
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline" onclick="pmpCloseModal('modal-project')">Cancel</button>
      <button class="btn btn-primary" onclick="createProject()">Create Project →</button>
    </div>
  </div>
</div>

<!-- Add/Edit Resource -->
<div class="modal-bg" id="modal-resource">
  <div class="modal" style="max-width:560px">
    <div class="modal-header"><div class="modal-title">Resource</div><button class="modal-close" onclick="pmpCloseModal('modal-resource')">✕</button></div>
    <div class="modal-body" style="padding:20px 24px;display:grid;grid-template-columns:1fr 1fr;gap:14px">
      <div style="grid-column:1/-1">
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Resource Name *</label>
        <input class="inp" id="rf-name" placeholder="Full name" style="width:100%">
      </div>
      <div>
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Role / Position</label>
        <input class="inp" id="rf-role" placeholder="e.g. Senior Developer" style="width:100%">
      </div>
      <div>
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Team</label>
        <input class="inp" id="rf-team" placeholder="e.g. Engineering" style="width:100%">
      </div>
      <div>
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Department</label>
        <input class="inp" id="rf-dept" placeholder="e.g. Product" style="width:100%">
      </div>
      <div>
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Allocation %</label>
        <input class="inp" id="rf-alloc" type="number" min="0" max="100" value="100" style="width:100%">
      </div>
      <div>
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Reporting Manager</label>
        <input class="inp" id="rf-manager" placeholder="Manager name" style="width:100%">
      </div>
      <div>
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Email</label>
        <input class="inp" id="rf-email" type="email" placeholder="email@example.com" style="width:100%">
      </div>
      <div style="grid-column:1/-1">
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Project Assignment <span style="font-weight:400;text-transform:none">(hold Ctrl to select multiple)</span></label>
        <select class="inp" id="rf-projects" multiple style="width:100%;min-height:80px;padding:8px"></select>
      </div>
      <div style="grid-column:1/-1">
        <label style="font-size:11.5px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:5px">Skills</label>
        <input class="inp" id="rf-skills" placeholder="e.g. React, Python, SQL" style="width:100%">
      </div>
    </div>
    <div class="modal-footer" style="padding:14px 24px;display:flex;justify-content:flex-end;gap:10px;border-top:1px solid var(--border)">
      <button class="btn btn-outline" onclick="pmpCloseModal('modal-resource')">Cancel</button>
      <button class="btn btn-primary" onclick="saveResource()">Add Resource</button>
    </div>
  </div>
</div>

<!-- Add Milestone -->
<div class="modal-bg" id="modal-milestone">
  <div class="modal">
    <div class="modal-header"><div class="modal-title">Add Milestone</div><button class="modal-close" onclick="pmpCloseModal('modal-milestone')">✕</button></div>
    <div class="modal-sub">Define a key checkpoint for this project.</div>
    <div class="inp-group"><label class="inp-label">Milestone Name *</label><input class="inp" id="ms-name" placeholder="e.g. Requirements Gathering"></div>
    <div class="inp-group"><label class="inp-label">Description</label><textarea class="inp" id="ms-desc" placeholder="What needs to be achieved?"></textarea></div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">Target Date</label><input class="inp" type="date" id="ms-date"></div>
      <div class="inp-group"><label class="inp-label">Owner</label><input class="inp" id="ms-owner" placeholder="Name"></div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline" onclick="pmpCloseModal('modal-milestone')">Cancel</button>
      <button class="btn btn-primary" onclick="saveMilestone()">Add Milestone →</button>
    </div>
  </div>
</div>

<!-- Add Client -->
<div class="modal-bg" id="modal-client">
  <div class="modal modal-lg">
    <div class="modal-header"><div class="modal-title">Add Client</div><button class="modal-close" onclick="pmpCloseModal('modal-client')">✕</button></div>
    <div class="modal-sub">Fill in client onboarding details.</div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">Client Name *</label><input class="inp" id="cl-name" placeholder="Client name"></div>
      <div class="inp-group"><label class="inp-label">Client Contact</label><input class="inp" id="cl-contact" placeholder="Contact name"></div>
    </div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">Start Date</label><input class="inp" type="date" id="cl-start"></div>
      <div class="inp-group"><label class="inp-label">Go Live Date</label><input class="inp" type="date" id="cl-golive"></div>
    </div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">Onshore Lead</label><input class="inp" id="cl-onshore" placeholder="Onshore lead"></div>
      <div class="inp-group"><label class="inp-label">OPS Lead</label><input class="inp" id="cl-opslead" placeholder="OPS lead"></div>
    </div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">SPL</label><input class="inp" id="cl-spl" placeholder="SPL"></div>
      <div class="inp-group"><label class="inp-label">Email</label><input class="inp" type="email" id="cl-email" placeholder="client@company.com"></div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline" onclick="pmpCloseModal('modal-client')">Cancel</button>
      <button class="btn btn-primary" onclick="savePmpClient()">Add Client →</button>
    </div>
  </div>
</div>

<!-- Quick Task -->
<div class="modal-bg" id="modal-quick-task">
  <div class="modal">
    <div class="modal-header"><div class="modal-title">Quick Add Task</div><button class="modal-close" onclick="pmpCloseModal('modal-quick-task')">✕</button></div>
    <div class="modal-sub">Add a task to any milestone.</div>
    <div class="inp-group"><label class="inp-label">Project</label><select class="inp" id="qt-proj" onchange="qtPopMs()"></select></div>
    <div class="inp-group"><label class="inp-label">Milestone</label><select class="inp" id="qt-ms"></select></div>
    <div class="inp-group"><label class="inp-label">Task *</label><input class="inp" id="qt-text" placeholder="Describe the task…"></div>
    <div class="inp-group"><label class="inp-label">Assignee</label><input class="inp" id="qt-who" placeholder="Name"></div>
    <div class="modal-footer">
      <button class="btn btn-outline" onclick="pmpCloseModal('modal-quick-task')">Cancel</button>
      <button class="btn btn-primary" onclick="saveQuickTask()">Add Task →</button>
    </div>
  </div>
</div>

<!-- Create Task (full) -->
<div class="modal-bg" id="modal-create-task">
  <div class="modal">
    <div class="modal-header"><div class="modal-title">Create Task</div><button class="modal-close" onclick="pmpCloseModal('modal-create-task')">✕</button></div>
    <div class="modal-sub">Task maps to Client → Project → Milestone.</div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">Project *</label><select class="inp" id="ct-proj" onchange="ctPopMs()"></select></div>
      <div class="inp-group"><label class="inp-label">Client (auto)</label><input class="inp" id="ct-client-display" readonly placeholder="Auto from project" style="background:var(--surface3);"></div>
    </div>
    <div class="inp-group"><label class="inp-label">Milestone *</label><select class="inp" id="ct-ms"></select></div>
    <div class="inp-group"><label class="inp-label">Task Name *</label><input class="inp" id="ct-text" placeholder="Describe the task…"></div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">Assignee</label><input class="inp" id="ct-who" placeholder="Team member name"></div>
      <div class="inp-group"><label class="inp-label">Priority</label><select class="inp" id="ct-prio"><option value="normal">Normal</option><option value="high">High</option><option value="critical">Critical</option><option value="low">Low</option></select></div>
    </div>
    <div class="form-row">
      <div class="inp-group"><label class="inp-label">Start Date</label><input class="inp" type="date" id="ct-start"></div>
      <div class="inp-group"><label class="inp-label">Due Date</label><input class="inp" type="date" id="ct-due"></div>
    </div>
    <div class="inp-group">
      <label class="inp-label">Status</label>
      <select class="inp" id="ct-status"><option value="to-do">To Do</option><option value="backlog">Backlog</option><option value="in-progress">In Progress</option><option value="review">Review</option><option value="done">Done</option></select>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline" onclick="pmpCloseModal('modal-create-task')">Cancel</button>
      <button class="btn btn-primary" onclick="saveCreatedTask()">Create Task →</button>
    </div>
  </div>
</div>

<!-- Toasts -->
<div class="toast-wrap" id="toastWrap"></div>